import React, { Component } from 'react';
import { BasePopoverPanel } from 'crazyEditor/components/EditorUI/BaseUI/index';
import ColorPicker from 'crazyEditor/components/EditorUI/BaseUI/ColorPicker/ColorPicker';
import _ from 'lodash';
import { connect } from 'react-redux';
import { closeLazyPanel } from 'crazyEditor/redux/modules/panel/panel';
import { setElementUpdatePreview, clearElementUpdatePreview, applyElementUpdatePreview} from 'crazyEditor/redux/modules/element/actions/previewElementActions';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { getSelectedElements } from 'crazyEditor/redux/modules/element/elementSelectors';

@connect(
  (state) => ({
    selectedElements: getSelectedElements(state),
    templateId: state.template.id
  }),
  {closeLazyPanel, setElementUpdatePreview, clearElementUpdatePreview, applyElementUpdatePreview}
)
@Radium
export default class ColorPanel extends Component {
  constructor(props) {
    super(props);
    const { selectedElements, panelProps} = this.props;
    const { selectedElementIds, propNameToUpdate } = panelProps;

    this.state = {
      defaultValue: _.get(selectedElements[0], propNameToUpdate)
    };
    this.onChange = this.onChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onCancel = this.onCancel.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const {selectedElements, panelProps} = nextProps;
    const {propNameToUpdate} = panelProps;
    if (this.props.open !== nextProps.open) {
      this.setState({defaultValue: _.get(selectedElements[0], propNameToUpdate)});
    }
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.open !== this.props.open;
  }

  onChange(color) {
    const { panelProps, setElementUpdatePreview } = this.props;
    const { selectedElementIds, propNameToUpdate } = panelProps;
    const elementUpdate = {};
    _.set(elementUpdate, propNameToUpdate, 'rgba(' + color.rgb.r + ', ' + color.rgb.g + ', ' + color.rgb.b + ', ' + color.rgb.a + ')');
    setElementUpdatePreview(selectedElementIds, elementUpdate);
  }

  onCancel() {
    const { closeLazyPanel, panelName, clearElementUpdatePreview} = this.props;

    clearElementUpdatePreview();
    closeLazyPanel(panelName);
  }

  onSelect() {
    const { closeLazyPanel, applyElementUpdatePreview } = this.props;
    applyElementUpdatePreview();
    closeLazyPanel(this.props.panelName);
  }

  render() {
    const { templateId } = this.props;
    const {defaultValue} = this.state;
    return (
      <BasePopoverPanel
        panelName={this.props.panelName}
        anchorEl={this.props.anchorEl}
        open={this.props.open}
        onRequestClose={this.onSelect}
      >
        <ColorPicker
          onChange={this.onChange}
          onSelect={this.onSelect}
          onCancel={this.onCancel}
          templateId={templateId}
          presetColors={['#000000', '#ffffff']}
          defaultValue={defaultValue}
        />
      </BasePopoverPanel>
    );
  }
}

ColorPanel.propTypes = {
  panelName: PropTypes.string.isRequired,
  anchorEl: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  panelProps: PropTypes.object,
  selectedElementIds: PropTypes.array.isRequired,
};

ColorPanel.defaultProps = {
  selectedElementIds: [],
};